"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var util_1 = require("@aperza/util");
var appConfig = util_1.AppService.appConfig();
var FooterSocialLinks = /** @class */ (function (_super) {
    __extends(FooterSocialLinks, _super);
    function FooterSocialLinks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FooterSocialLinks.prototype.render = function () {
        return (react_1.default.createElement("ul", { className: "strip footer-social-links", style: { justifyContent: 'space-between' } },
            react_1.default.createElement("li", null,
                react_1.default.createElement("a", { className: "sns-fb", href: "https://www.facebook.com/news.aperza/" },
                    react_1.default.createElement("i", { className: "fa fa-facebook-square" }))),
            react_1.default.createElement("li", null,
                react_1.default.createElement("a", { className: "sns-ins", href: "https://www.instagram.com/monozukuri_news/" },
                    react_1.default.createElement("i", { className: "fa fa-instagram" }))),
            react_1.default.createElement("li", null,
                react_1.default.createElement("a", { className: "sns-tw", href: "https://twitter.com/news_aperza" },
                    react_1.default.createElement("i", { className: "fa fa-twitter" }))),
            react_1.default.createElement("li", null,
                react_1.default.createElement("a", { className: "sns-yt", href: "https://www.youtube.com/channel/UCEPoZF8KKr2Hm0QiBympWOA/videos" },
                    react_1.default.createElement("i", { className: "fa fa-youtube-play" })))));
    };
    return FooterSocialLinks;
}(react_1.default.Component));
exports.default = FooterSocialLinks;
